import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable()
export class ClinicalNoteFormService {

	private readonly forms: Record<string, FormGroup[]> = {};

	addForm(clinicalNoteId: string, form: FormGroup) {
		(this.forms[clinicalNoteId] ??= []).push(form);
	}

	isInvalid(clinicalNoteId: string): boolean {
		return this.forms[clinicalNoteId]?.some(f => f.invalid) ?? false;
	}

	deregister(clinicalNoteId: string) {
		delete this.forms[clinicalNoteId];
	}
}
